export const getMeasurementTemplateList = state => {
    return state.list
}

export const getMeasurementTemplateDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/measurementTemplate/getters.js